import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

/** For the work a calculator can never price: send them to a human. */
export const GeneralFallbackCta = ({ onContact }) => (
  <section className="mx-auto max-w-6xl px-4 pt-14 sm:px-6">
    <div
      data-testid="general-fallback-cta"
      className="overflow-hidden rounded-xl border border-border bg-[color:var(--tt-surface-2)]"
    >
      <div className="flex flex-col gap-5 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8">
        <div className="max-w-2xl">
          <h2 className="text-xl font-bold text-foreground sm:text-2xl">
            Don't see your situation covered above?
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
            Trust audits, longer backlogs, bigger businesses, group structures, public-sector work
            — plenty of what we do doesn't fit a calculator. Tell us what you need and we'll put
            together a custom quote.
          </p>
        </div>
        <Button
          type="button"
          onClick={onContact}
          data-testid="general-fallback-button"
          className="h-12 shrink-0 px-6 text-base font-bold"
        >
          Contact us directly
          <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
        </Button>
      </div>
    </div>

    <p className="mt-6 text-center text-xs leading-relaxed text-muted-foreground">
      Already have a quote reference?{" "}
      <a href="/verify-quote" className="tt-link">
        Verify it here
      </a>{" "}
      to see the original figures exactly as we stored them.
    </p>
  </section>
);
